<script>
  import {
    selectedArea,
    selectedPart,
    selectedProcedures,
    showDialog,
    step,
  } from '../../store/common';

  const classByStep = {
    1: 'uk-modal',
    2: 'uk-modal uk-modal-container',
    3: 'uk-modal',
    4: 'uk-modal',
  };

  const closeHandler = () => {
    showDialog.set(false);
    step.set(1);
    selectedProcedures.set([]);
    selectedArea.set({});
    selectedPart.set({});
  };

  $: console.log('$showDialog', $showDialog);
</script>

<div
  class={`uk-flex-top ${$showDialog ? 'uk-flex uk-open' : ''} ${
    classByStep[$step]
  }`}
  style={`${$showDialog ? 'display: flex;' : ''}`}
  id="modal-quote"
  data-uk-modal
>
  <form class="uk-modal-dialog uk-margin-auto-vertical" data-uk-overflow-auto>
    <button
      class="uk-modal-close-default"
      type="button"
      data-uk-close
      on:click={closeHandler}
    />

    <slot>по умолчанию</slot>

    <slot name="footer" />
  </form>
</div>
